import React from "react";
import "assets/css/safexpay-web.css";
import "./Registration.css";
import Spinner from "reactstrap/lib/Spinner";
import CryptoJS from "crypto-js";
import { base_url } from "assets/utils/const";
import { emailValidation } from "assets/utils/constFuntion";
class TempLogin extends React.Component {
  state = {
    isLoaded: false,
    email: "",
    isValidEmail: true,
  };

  handleSubmit = (event) => {
    event.preventDefault();
    if (!this.handleEmail()) {
      return false;
    }
    this.setState({ isLoaded: true, usernameErr: "", passwordErr: "" });

    var uname = event.target.txtUsername.value;
    var upass = event.target.txtPassword.value;
    var key = "oqUl4D0LqA4plZw4reAX/K3UKJoQdet0k/N6X6K4Y5k=";
    var base64IV = "0123456789abcdef";

    var parsedBase64Key = CryptoJS.enc.Base64.parse(key);
    var IV = CryptoJS.enc.Utf8.parse(base64IV);
    // Encryption process
    if (typeof upass !== "string") {
      upass = upass.toString();
    }

    // this is Base64-encoded encrypted data
    var encryptedData = CryptoJS.AES.encrypt(upass, parsedBase64Key, {
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
      iv: IV,
    });
    // console.log("encryptedData = ", encryptedData.toString());
    const encryptedCipherText = encryptedData.toString();

    fetch(`${base_url}api/merchantLogin`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        user_id: uname,
        password: encryptedCipherText,
      }),
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log(result);
          this.setState({ isLoaded: false });
          if (result.statusCode == "200") {
            this.setState({ passwordErr: "", usernameErr: "" });
            localStorage.setItem("umail", uname);
            const payloadDetails = JSON.parse(result.payLoad);
            localStorage.setItem("TempAuthtoken", payloadDetails.Authtoken);
            window.location.href = "/setpassword";
          } else {
            if (result.payLoad === "Invalid User Id.") {
              this.setState({ usernameErr: result.payLoad });
            } else {
              this.setState({ usernameErr: "" });
            }
            if (result.payLoad === "Password entered is not correct.") {
              this.setState({ passwordErr: result.payLoad });
            } else {
              this.setState({ passwordErr: "" });
            }
          }
        },
        (error) => {
          this.setState({ isLoaded: false });
          alert("Failed");
        }
      );
  };
  handleEmail = () => {
    if (
      emailValidation(this.state.email.trim()) &&
      this.state.email &&
      this.state.email.length < 65
    ) {
      let sp = this.state.email.split("@")[1].split(".");
      if (sp.length > 3) {
        document.getElementById("txtUsername").classList.add("is-invalid");
        this.setState({ isValidEmail: false });
        return false;
      } else {
        document.getElementById("txtUsername").classList.remove("is-invalid");
        this.setState({ isValidEmail: true });
        return true;
      }
    } else {
      document.getElementById("txtUsername").classList.add("is-invalid");
      this.setState({ isValidEmail: false });
      return false;
    }
  };
  render() {
    return (
      <>
        <section className="dv-Registration-content">
          <div className="container">
            <div className="row">
              <div
                className="col-md-6 dv-instruction"
                data-aos="fade-right"
                data-aos-duration="1000"
              >
                <h1 className="section-heading">
                  Simplify your payment &amp; grow your business.
                </h1>
                <ul className="tick">
                  <li>Easily accept payments from your customers.</li>
                  <li>Streamline payments to your vendors or partners.</li>
                  <li>Create your own payments or banking platform.</li>
                </ul>
              </div>
              <div
                className="col-md-6 form-div"
                data-aos="fade-up"
                data-aos-duration="1000"
              >
                <form
                  onSubmit={this.handleSubmit}
                  className="dv-login-form dv-form"
                >
                  <h1 className="section-heading border-heading">Login</h1>
                  <p className="text-center mx-note color-lightblue mb-3">
                    Kindly check your registered email for Username &amp;
                    Temporary Password.
                  </p>
                  <div className="form-group mx-5">
                    <label htmlFor="txtUsername">Email</label>
                    <input
                      type="text"
                      required
                      className="form-control"
                      name="txtUsername"
                      id="txtUsername"
                      placeholder="Enter Email"
                      value={this.state.email}
                      onChange={(e) => this.setState({ email: e.target.value })}
                      onBlur={this.handleEmail}
                    />
                    {!this.state.isValidEmail && (
                      <small className="err">Please Enter a valid email</small>
                    )}
                    <div className="err" style={{ textAlign: "start" }}>
                      {this.state.usernameErr}
                    </div>
                  </div>
                  <div className="form-group mx-5">
                    <label htmlFor="txtPassword">Temporary Password</label>
                    <input
                      type="password"
                      required
                      className="form-control"
                      name="txtPassword"
                      id="txtPassword"
                      placeholder="Enter Temporary Password"
                    />
                    <div className="err" style={{ textAlign: "start" }}>
                      {this.state.passwordErr}
                    </div>
                  </div>

                  {/* <p className="text-center">
                                        <a href="/" className="btn btn-forgtpass btn-link">Forgot password</a>
                                    </p> */}
                  <div className="btn-holder mt-5 text-center">
                    <button
                      type="submit"
                      className={
                        this.state.isLoaded
                          ? `btn btn-next btn-gradient disable-btn`
                          : `btn btn-next btn-gradient`
                      }
                      disabled={this.state.isLoaded}
                    >
                      NEXT
                      {this.state.isLoaded ? (
                        <Spinner
                          size="sm"
                          color="light"
                          className="btn-loader"
                        />
                      ) : null}
                    </button>
                  </div>

                  <div className="dv-bottom-bg mt-5">
                    <div className="dv-help">
                      Need help?{" "}
                      <a href="/support" className="lnk-contact text-underline">
                        SUPPORT
                      </a>
                    </div>
                    <div className="first-bottom-bg"></div>
                    <div className="second-bottom-bg"></div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default TempLogin;
